import { graphqlClient } from '../graphqlClient';

const getInfrastructureStatus = async () => {
  const query = `
    query {
      infrastructureStatus {
        uptimePercentage
        status
        latencyMs
      }
    }
  `;

  const response = await graphqlClient.query(query);
  return response.infrastructureStatus;
};

const getSystemStatus = async () => {
  const query = `
    query {
      systemStatus {
        infrastructure {
          uptimePercentage
          status
          latencyMs
        }
        apiGateway {
          uptimePercentage
          status
          latencyMs
        }
        database {
          uptimePercentage
          status
          latencyMs
        }
      }
    }
  `;

  const response = await graphqlClient.query(query);
  return response.systemStatus;
};

const getApiGatewayLogs = async (limit = 100) => {
  const query = `
    query GetApiGatewayLogs($limit: Int) {
      apiGatewayLogs(limit: $limit) {
        logs {
          id
          status
          latencyMs
          createdAt
        }
        serverStartTime
        databaseConnectionTime
        currentMemoryUsage
        totalLogEntries
      }
    }
  `;

  const response = await graphqlClient.query(query, { limit });
  return response.apiGatewayLogs;
};

const getDatabaseLogs = async (limit = 100) => {
  const query = `
    query GetDatabaseLogs($limit: Int) {
      databaseLogs(limit: $limit) {
        logs {
          id
          status
          latencyMs
          createdAt
        }
        serverStartTime
        databaseConnectionTime
        currentMemoryUsage
        totalLogEntries
      }
    }
  `;

  const response = await graphqlClient.query(query, { limit });
  return response.databaseLogs;
};

const getInfrastructureLogs = async (limit = 100) => {
  const query = `
    query GetInfrastructureLogs($limit: Int) {
      infrastructureLogs(limit: $limit) {
        logs {
          id
          status
          latencyMs
          createdAt
        }
        serverStartTime
        databaseConnectionTime
        currentMemoryUsage
        totalLogEntries
      }
    }
  `;

  const response = await graphqlClient.query(query, { limit });
  return response.infrastructureLogs;
};

const getApiGatewayLogsFiltered = async (startDate, endDate, limit = 100) => {
  const query = `
    query GetApiGatewayLogsFiltered($startDate: String, $endDate: String, $limit: Int) {
      apiGatewayLogsFiltered(startDate: $startDate, endDate: $endDate, limit: $limit) {
        logs {
          id
          status
          latencyMs
          createdAt
        }
        serverStartTime
        databaseConnectionTime
        currentMemoryUsage
        totalLogEntries
      }
    }
  `;

  const response = await graphqlClient.query(query, { startDate, endDate, limit });
  return response.apiGatewayLogsFiltered;
};

const getDatabaseLogsFiltered = async (startDate, endDate, limit = 100) => {
  const query = `
    query GetDatabaseLogsFiltered($startDate: String, $endDate: String, $limit: Int) {
      databaseLogsFiltered(startDate: $startDate, endDate: $endDate, limit: $limit) {
        logs {
          id
          status
          latencyMs
          createdAt
        }
        serverStartTime
        databaseConnectionTime
        currentMemoryUsage
        totalLogEntries
      }
    }
  `;

  const response = await graphqlClient.query(query, { startDate, endDate, limit });
  return response.databaseLogsFiltered;
};

export { getInfrastructureStatus, getSystemStatus, getApiGatewayLogs, getDatabaseLogs, getInfrastructureLogs, getApiGatewayLogsFiltered, getDatabaseLogsFiltered };
export default getInfrastructureStatus;